import { Button } from '@rbilabs/components-library/build/components/button';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  margin: 0.3rem;
  padding: 0.5rem 1rem;
  background-color: ${Styles.color.white};
  border-radius: ${Styles.borderRadius};
  color: ${Styles.color.black};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 1rem;
  width: 100%;

  &:active,
  &:hover {
    background-color: ${Styles.color.white};
    transform: none;
  }

  &:focus {
    box-shadow: none;
  }
`;

export const IconContainer = styled.div`
  padding: 0.5rem;
  background-color: ${Styles.color.primary};
  border-radius: 100%;
`;
